<template>
    <div class="main-header-controls">
        <cart-popup-container
            :show="showCartPopup"
            @close="toggleCartPopup(false)"
        />

        <control-item
            title="Ulubione"
            :count="wishListProducts.length"
            @click="clickWishList"
        >
            <svg slot="icon" width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 7.18943H1.5H1ZM2.81284 2.81284L3.16639 3.16639L2.81284 2.81284ZM2.81284 11.566L2.45929 11.9196L2.81284 11.566ZM11.8165 20.5697L12.1713 20.2174L12.1701 20.2161L11.8165 20.5697ZM11.8439 20.5971L11.4903 20.9507L11.4903 20.9507L11.8439 20.5971ZM22.8201 2.81292L22.4665 3.16647V3.16647L22.8201 2.81292ZM18.4435 1.00008V0.500077V1.00008ZM14.0669 2.81292L14.4205 3.16647H14.4205L14.0669 2.81292ZM12.8165 4.06333L12.4629 4.41688C12.5567 4.51065 12.6839 4.56333 12.8165 4.56333C12.9491 4.56333 13.0763 4.51065 13.1701 4.41688L12.8165 4.06333ZM11.566 2.81284L11.9196 2.45929L11.9196 2.45929L11.566 2.81284ZM7.18943 1L7.18943 1.5L7.18943 1ZM1.5 7.18943C1.5 5.6805 2.09942 4.23337 3.16639 3.16639L2.45929 2.45929C1.20478 3.7138 0.5 5.41528 0.5 7.18943H1.5ZM3.1664 11.2125C2.09942 10.1455 1.5 8.69836 1.5 7.18943H0.5C0.5 8.96357 1.20478 10.6651 2.45929 11.9196L3.1664 11.2125ZM12.1701 20.2161L3.1664 11.2125L2.45929 11.9196L11.463 20.9233L12.1701 20.2161ZM11.4618 20.922C11.4713 20.9316 11.4808 20.9412 11.4903 20.9507L12.1974 20.2436C12.1887 20.2348 12.18 20.2261 12.1713 20.2174L11.4618 20.922ZM11.4903 20.9507C12.2227 21.6831 13.4102 21.6831 14.1426 20.9507L13.4355 20.2436C13.0936 20.5855 12.5393 20.5855 12.1974 20.2436L11.4903 20.9507ZM14.1426 20.9507L23.1736 11.9196L22.4665 11.2125L13.4355 20.2436L14.1426 20.9507ZM23.1736 11.9196C24.4281 10.6651 25.1329 8.96365 25.1329 7.1895H24.1329C24.1329 8.69843 23.5335 10.1456 22.4665 11.2125L23.1736 11.9196ZM25.1329 7.1895C25.1329 5.41536 24.4281 3.71388 23.1736 2.45936L22.4665 3.16647C23.5335 4.23345 24.1329 5.68057 24.1329 7.1895H25.1329ZM23.1736 2.45936C21.9191 1.20485 20.2176 0.500076 18.4435 0.500077V1.50008C19.9524 1.50008 21.3995 2.0995 22.4665 3.16647L23.1736 2.45936ZM18.4435 0.500077C16.6693 0.500077 14.9679 1.20485 13.7134 2.45937L14.4205 3.16647C15.4874 2.0995 16.9346 1.50008 18.4435 1.50008V0.500077ZM13.7134 2.45937L12.4629 3.70977L13.1701 4.41688L14.4205 3.16647L13.7134 2.45937ZM11.2125 3.1664L12.4629 4.41688L13.1701 3.70977L11.9196 2.45929L11.2125 3.1664ZM7.18943 1.5C8.69836 1.5 10.1455 2.09942 11.2125 3.1664L11.9196 2.45929C10.6651 1.20478 8.96357 0.5 7.18943 0.5L7.18943 1.5ZM3.16639 3.16639C4.23337 2.09942 5.6805 1.5 7.18943 1.5L7.18943 0.5C5.41528 0.5 3.7138 1.20478 2.45929 2.45929L3.16639 3.16639Z" fill="#246450"/>
            </svg>
        </control-item>

        <control-item
            @click="clickProfile"
            title="Moje konto"
        >
            <svg slot="icon" width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="none" d="M15.6667 20.0003L2.33334 20.0003C1.59696 20.0003 1 19.4034 1 18.667C1 16.4615 2.36827 14.4875 4.43344 13.7135L4.84346 13.5598C7.52346 12.5554 10.4765 12.5554 13.1565 13.5598L13.5666 13.7135C15.6317 14.4875 17 16.4615 17 18.667C17 19.4034 16.403 20.0003 15.6667 20.0003Z" stroke="#246450" stroke-linecap="square" stroke-linejoin="round"/>
                <path fill="none" d="M6.96716 9.62242C8.24314 10.2779 9.75687 10.2779 11.0329 9.62242V9.62242C12.2204 9.01242 13.0712 7.90139 13.3505 6.59592L13.4251 6.2475C13.7107 4.9125 13.4056 3.51919 12.5881 2.42578L12.4684 2.26566C11.6509 1.17209 10.3654 0.528154 9.00001 0.528154V0.528154C7.6346 0.528154 6.34916 1.17209 5.53157 2.26566L5.41186 2.42578C4.59439 3.51919 4.28927 4.9125 4.57492 6.2475L4.64948 6.59592C4.92882 7.90139 5.77964 9.01242 6.96716 9.62242V9.62242Z" stroke="#246450" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>
        </control-item>

        <control-item
            title="Koszyk"
            :count="cartProductsCount"
            @click="clickCart"
        >
            <svg slot="icon" width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.80221 8.98524C2.9159 8.22734 3.56696 7.66666 4.33333 7.66666V7.66666H16.3333V7.66666C17.0997 7.66666 17.7508 8.22734 17.8645 8.98524L19.2791 18.4162C19.4832 19.7766 18.4296 21 17.054 21H3.61267C2.23709 21 1.18351 19.7766 1.38756 18.4162L2.80221 8.98524Z" stroke="#246450" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14.3333 10.3333V5C14.3333 2.79086 12.5425 1 10.3333 1V1C8.12417 1 6.33331 2.79086 6.33331 5V10.3333" stroke="#1e1e1e" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </control-item>
    </div>
</template>

<script>
import Vue from "vue";
import store from './../store';
import ControlItem from "../components/header/ControlItem";
import {DefaultScreenDetector} from './../../libraries/screen-detector/DefaultScreenDetector';
import {SecurityContainer} from "../../libraries/SecurityContainer";
import {HashRouter} from "./../../libraries/HashRouter";

const HeaderControlsComponent = {
        name: "HeaderControls",
        components: {
            CartPopupContainer: () => import("./CartPopupContainer"),
            ControlItem
        },
        data() {
          return {
              showCartPopup: false,
              showWishListPopup: false,
              userIsLogged: SecurityContainer.userIsLogged(),
          }
        },
        computed: {
            wishListProducts() {
                return this.$store.getters['wishList/products'];
            },

            cartProductsCount() {
                return this.$store.getters['cart/cartProductsCount'];
            },

            isProductPage() {
                return typeof CURRENT_PRODUCT_ID !== 'undefined';
            }
        },
        methods: {
            hoverCartPopup(show) {
                if (!DefaultScreenDetector.isMobileView()) {
                    this.toggleCartPopup(show);
                }
            },

            toggleCartPopup(show) {
                HashRouter.redirect('');
                this.showWishListPopup = false;
                this.showCartPopup = show;
                document.querySelector('body').style.overflowY = show ? 'hidden' : 'scroll';

                if (DefaultScreenDetector.isMobileView()) {
                    document.querySelector('nav').style.zIndex = show ? '99' : '1000';
                }

                if (typeof zE == 'function') {
                    if (window.zE.widget === 'messenger') {
                        if (show) {
                            zE("messenger", "hide");
                        } else {
                            zE("messenger", "show");
                        }
                    } else {
                        if (show) {
                            zE("webWidget", "hide");
                        } else {
                            zE("webWidget", "show");
                        }
                    }
                }
            },

            clickCart() {
                this.toggleCartPopup(!this.showCartPopup);
            },

            clickWishList() {
                if (false === this.userIsLogged) {
                    HashRouter.redirect('login-modal', {ref: 'wishlist.php', type: "wishlist"});
                    return;
                }

                document.location.href = "wishlist.php";
            },

            clickProfile() {
                if (false === this.userIsLogged) {
                    this.showCartPopup = false;
                    this.showWishListPopup = false;
                    HashRouter.redirect('login-modal', {ref: 'user.php'});
                    return;
                }

                document.location.href = "user.php"
            },
        },
        async mounted() {
            try {
                await this.$store.dispatch('wishList/fetchData');
            } catch (error) {
                toast.error("Wyst�pi� b��d podczas pobierania schowka")
            }

            try {
                await this.$store.dispatch('cart/fetchData');
            } catch (error) {
                toast.error("Wyst�pi� b��d podczas pobierania koszyka")
            }

            if (typeof showMiniCart !== 'undefined' && parseInt(showMiniCart) === 1) {
                this.toggleCartPopup(true);
            }
        }
    };

    const HeaderControlsInstance = new Vue({
        store,
        render: h => h(HeaderControlsComponent),
    });

    export function initialize() {
        HeaderControlsInstance.$mount('.main-header-controls')
    }

    export {
        HeaderControlsInstance
    }
    export default HeaderControlsComponent;
</script>
